"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_CONFIRMATION = exports.SUBSCRIPTION_PACKAGES = void 0;
exports.berlinDate = berlinDate;
exports.subscriptionSettings = subscriptionSettings;
exports.resolveSubscription = resolveSubscription;
exports.SUBSCRIPTION_PACKAGES = {
    STANDARD_1: { label: "1 Therapeut / 10 Lernende", therapistLimit: 1, learnerLimit: 10 },
    STANDARD_2: { label: "2 Therapeuten / 25 Lernende", therapistLimit: 2, learnerLimit: 25 },
    STANDARD_3: { label: "5 Therapeuten / 50 Lernende", therapistLimit: 5, learnerLimit: 50 },
};
function berlinDate(now = new Date()) {
    return new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Berlin", year: "numeric", month: "2-digit", day: "2-digit" }).format(now);
}
function subscriptionSettings(settings) {
    const saved = settings?.subscription;
    return { current: saved?.current ?? null, paused: saved?.paused === true, scheduled: saved?.scheduled ?? null };
}
function resolveSubscription(settings, usage, now = new Date()) {
    const saved = subscriptionSettings(settings);
    const due = saved.scheduled && saved.scheduled.effectiveOn <= berlinDate(now);
    const current = due ? saved.scheduled : saved.current;
    const reasons = [];
    if (saved.paused)
        reasons.push("PAUSED");
    if (current && (usage.therapists > current.therapistLimit || usage.learners > current.learnerLimit || usage.administrators > 1))
        reasons.push("CAPACITY");
    return { current, scheduled: due ? null : saved.scheduled, paused: saved.paused, usage, restricted: reasons.length > 0, reasons };
}
exports.EXPORT_CONFIRMATION = "Ich habe den Export heruntergeladen und seine Lesbarkeit geprüft. Mir ist bewusst, dass die Daten durch die anschließende Löschung aus Calepia entfernt werden. Für die weitere Aufbewahrung oder Löschung der exportierten Dateien ist unsere Einrichtung verantwortlich.";
//# sourceMappingURL=subscription.js.map